import { CJEDTEvent } from '@teetsh/app/src/types/event';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';
import { findLCM } from '@teetsh/app/src/utils/lcm';
import { getClassroomsGrouppedByDays } from './getClassroomsGrouppedByDays';
import { computeLCMForEvts } from './computeLCMForEvts';
import { getEventsOfClassroomAndDay } from './getEventsOfClassroomAndDay';

function getLCMOfSingleDayAndSingleClassroom(
  classroomsOrg: ClassroomsOrg,
  day: number,
  seances: CJEDTEvent[],
  classrooms: Classroom[],
) {
  if (classroomsOrg === 'unified') {
    const matchingSeances = getEventsOfClassroomAndDay(
      seances,
      day,
      classrooms.map(c => c.id),
    );
    return computeLCMForEvts(
      matchingSeances.map(e => ({ ...e, classroomIds: ['WE_DONT_CARE'] })),
    );
  }

  return classrooms.reduce((accc, classroom) => {
    const events = getEventsOfClassroomAndDay(seances, day, [classroom.id]);
    const classroomLCM = computeLCMForEvts(events);
    return classroomLCM > accc ? classroomLCM : accc;
  }, 1);
}

export const getLCMOfEvents = (
  evts: CJEDTEvent[],
  classrooms: Classroom[],
  days: number[],
  classroomsOrg: ClassroomsOrg,
) => {
  const classroomsGroupedByDays = getClassroomsGrouppedByDays(days, classrooms);

  const fromClassrooms = days.reduce(
    (acc, day) => {
      const classroomsForThatDay = classroomsGroupedByDays[day] || [];
      const lcmForSingleDaySingleClassroom =
        getLCMOfSingleDayAndSingleClassroom(
          classroomsOrg,
          day,
          evts,
          classroomsForThatDay,
        );
      if (classroomsOrg === 'split') {
        return [
          ...acc,
          lcmForSingleDaySingleClassroom,
          // This deserve explanation...
          // We want every day to have to same width hence the same colSpan
          // So we need the lcm to be divisible by the number of classrooms
          // That's why we multiply by the number of classrooms.
          classroomsForThatDay.length * lcmForSingleDaySingleClassroom,
        ];
      }
      return [...acc, lcmForSingleDaySingleClassroom];
    },
    [1],
  );
  return findLCM(fromClassrooms.filter(l => l > 0));
};
